import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import moment from 'moment';

import styles from './styles';

class NotesTable extends Component {
  static propTypes = {
    notes: PropTypes.array,
    // onEdit: PropTypes.func.isRequired,
    // onRemove: PropTypes.func.isRequired,
  };

  renderNoData() {
    return (<TableRow key="nodata">
      <TableRowColumn colSpan={3} style={styles.noDataRow}>
        <div>No notes are available</div>
      </TableRowColumn>
    </TableRow>);
  }

  renderRow = (note) => {
    return (<TableRow key={note.id} selectable={false}>
      <TableRowColumn style={styles.dateTimeCol}>{ note.created ? moment(note.created.at).format('lll') : null }</TableRowColumn>
      <TableRowColumn style={styles.createdByCol}>{note.created ? note.created.by : null}</TableRowColumn>
      <TableRowColumn style={styles.notesCol}>{note.notes}</TableRowColumn>
      {/*<TableRowColumn style={styles.actionCol}>*/}
      {/*<IconButton tooltip="Skip Stage" tooltipPosition="bottom-center" onClick={() => this.handleSkipStage(stage)}>*/}
      {/*<FontIcon className="material-icons" style={styles.completeStageIcon}>delete</FontIcon>*/}
      {/*</IconButton>*/}
      {/*<IconButton tooltip="Complete Stage" tooltipPosition="bottom-center"*/}
      {/*onClick={() => this.handleCompleteStage(stage)}>*/}
      {/*<FontIcon className="material-icons" style={styles.completeStageIcon}>done</FontIcon>*/}
      {/*</IconButton>*/}
      {/*</TableRowColumn>*/}
    </TableRow>);
  };

  render() {
    const notes = this.props.notes || [];

    return (<Table selectable={false}>
      <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
        <TableRow>
          <TableHeaderColumn style={styles.dateTimeCol}>Date</TableHeaderColumn>
          <TableHeaderColumn style={styles.createdByCol}>Name</TableHeaderColumn>
          <TableHeaderColumn style={styles.notesCol}>Notes</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        {notes.length > 0 ? notes.map(this.renderRow) : this.renderNoData()}
      </TableBody>
    </Table>);
  }

}

export default NotesTable;



// WEBPACK FOOTER //
// ./src/components/NotesTable/index.js